import React, { useCallback, useState, useLayoutEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { Tag } from "rsuite"
import { format,startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import _ from "lodash"
import async from "async"
import { Line } from '@ant-design/plots';
import { Table, Spin } from "antd"
import getDates from "../../constant/getDates"
import { DataGrid } from '@mui/x-data-grid';
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service";
import { Tooltip } from "antd";
import MenuDivider from "antd/lib/menu/MenuDivider";

const ReportBusiness = () => {
    const columns = [
        { dataIndex: 'date', title: 'Thời gian', width: 150, fixed: 'left' },
        {
            dataIndex: 'totalPrice',
            title: 'Doanh số thuần',
            width: 150,
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(data)}</p>
                )
            },
        },
        {
            dataIndex: 'paid',
            title: 'Tổng tiền đã thu',
            width: 150,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.paid) - Number(b.paid),
                multiple: 1,
            },
        },
        {
            dataIndex: 'paidNoTax',
            title: 'Tổng thực thu bán hàng',
            width: 150,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.paidNoTax) - Number(b.paid),
                multiple: 1,
            },
        },
        {
            dataIndex: 'countOrderNew',
            title: 'Tổng hoá đơn',
            width: 150,
            // width: 50 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{data}</p>
                )
            },
        },
        {
            dataIndex: 'proportion',
            title: <Tooltip className="show-tooltip" title='Tỷ lệ đơn hàng của ngày chia cho tổng đơn hàng của thơi gian chọn.'> Tỉ lệ đơn/tổng đơn <i className="fas fa-info-circle"></i></Tooltip>,
            width: 150,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data} %</p>
                )
            },
        },
        {
            dataIndex: 'countService',
            title: 'Tổng dịch vụ',
            width: 150,
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            dataIndex: 'aov',
            title: <Tooltip className="show-tooltip" title='Tỷ lệ thực thu của khách hàng chia cho số hoá đơn thực thu của khách hàng.'> AOV <i className="fas fa-info-circle"></i></Tooltip>,

            align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
        },
        {
            // dataIndex: 'paidTriet',
            title: 'Triệt lông',
            align: "start",
            render: (data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Tổng tiền: {convertCurrency(data.paidTriet)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countTriet}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovTriet)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countDa',
            title: 'Da',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Tổng tiền: {convertCurrency(data.paidDa)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countDa}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovDa)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countDa',
            title: 'Chăm sóc body',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Tổng tiền: {convertCurrency(data.paidBody)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countBody}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovBody)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Đầu triệt',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Tổng tiền: {convertCurrency(data.paidDauTriet)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countDauTriet}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovDauTriet)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Mỹ phẩm',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Tổng tiền: {convertCurrency(data.paidMyPham)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countMyPham}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovMyPham)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Gội',
            align: "start",
            render: (t,data) => {
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text1">Tổng tiền: {convertCurrency(data.paidGoi)}</p>
                        <p className="text2">Tổng hoá đơn: {data.countGoi}</p>
                        <p className="text3">AOV: {convertCurrency(data.aovGoi)}</p>
                    </div>
                )
            },
        },
    ];
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())),"yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            ([JSON.parse(StorageService.getItem("user_info")).stores[0].id])
        : [StorageService.getItem("currentStore")])
    const [sortBy, setSortBy] = useState(0)
    const [totalPaid, setTotalPaid] = useState(0)
    const [totalPaidNoTax, setTotalPaidNoTax] = useState(0)
    const [totalOrderNew, setTotalOrderNew] = useState(0)
    const [ordersByDaysCountBooking, setOrdersByDaysCountBooking] = useState([])
    const [totalPrice, setTotalPrice] = useState(0)
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const [listCategoryIds, setSistCategoryIds] = useState([2, 4, 5, 45, 46, 47])

    const [dataByCategory, setDataByCategory] = useState([])


    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))

    const [typeBHVV, setTypeBHVV] = useState(0)

    const handleRangeDate = useCallback((sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }, [startDate, endDate])
    const [pageSize, setPageSize] = useState(5)

    const handleStore = useCallback((e) => {
        setStore(e)
    }, [store])

    const handleSortBy = useCallback((e) => {
        setSortBy(e)
    }, [sortBy]);

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, endDate, startDate, sortBy, typeBHVV)
    }, [store, endDate, startDate, sortBy, typeBHVV])
    
    const fetchData = async (s, eD, sD, sBy, typeBHVV) => {
        let payload = {
            storeId: s,
            startDate: sD,
            endDate: eD,
            sortBy: sBy,
            typeBHVV
        }

        const rs = await axiosService(`api/reports/store/work/business`, "POST", payload)

        if (rs.data.code == 200) {
            const { data } = rs.data

            setTotalPaid(data.totalPaid)
            setTotalPaidNoTax(data.totalPaidNoTax)
            setTotalOrderNew(data.totalOrderNew)
            setTotalPrice(data.totalPrice)
            setRows(data.dataTable)
            setDataByCategory(data.dataByCategory)

            let rowsCountBooking = []
            let rowsCountBookingSuccess = []
            let rowsCountBookingService = []
            for (let item of data.dataTable.reverse()) {
                let rowCountBooking = {
                    date: item.date,
                    value: item.paid,
                    type: 'Tiền thực thu'
                }
                let rowCountBookingSuccess = {
                    date: item.date,
                    value: item.countOrderNew,
                    type: 'Đơn hàng mới'
                }
                let rowCountBookingService = {
                    date: item.date,
                    value: item.aov,
                    type: 'Aov'
                }
                rowsCountBooking.push(rowCountBooking)
                rowsCountBookingSuccess.push(rowCountBookingSuccess)
                rowsCountBookingService.push(rowCountBookingService)
            }
            setOrdersByDaysCountBooking([...rowsCountBooking, ...rowsCountBookingSuccess, ...rowsCountBookingService])
            let value = "yyyy-MM-dd"
                if (sortBy === 1) {
                    value = "ww"
                } else if (sortBy === 2) {
                    value = "MM"
                }
            setLoading(false)
        }
    
    }

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const config = useMemo(() => configChart(ordersByDaysCountBooking, convertCurrency), [ordersByDaysCountBooking])
    
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <div className={`${styles.background} container-fluid report-page`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                sortBy={sortBy} handleSortBy={handleSortBy}
                title={"Kinh doanh cơ sở"} type={"daily"}
                typeBHVV={typeBHVV} setTypeBHVV={setTypeBHVV}
                csvData={rows} isExport={isExport}
                handleExportData={handleExportData}
                header={
                    [
                        { label: 'Thời gian', key: "date" },
                        { label: "Số lượng lịch đặt", key: "count_booking" },
                        { label: "Số lượng lịch huỷ", key: "count_close" },
                        { label: "Số lượng lịch thành công", key: "count_success" },
                        { label: "Tỉ lệ huỷ/tổng lịch đặt", key: "proportion" },
                        { label: "Số lượng khách hàng phục vụ", key: "count_customer" },
                        { label: "Lượt dịch vụ", key: "count_service" },
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading}>
                <Row className="mt-2">
                    <Col xs={12} md={12}>
                        <Row className="h-100">
                            <Col xs={12} md={3} className="p-2">
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className="d-flex justify-content-between mb-2">
                                        <div className={styles.textTag3}> 
                                            <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ mọi nguồn (Offline + Online) bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>
                                                Tổng tiền đã thu: <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </div>
                                        <div className={styles.textTag}>
                                            {convertCurrency(totalPaid)}
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                        <div className={styles.textTag3}> 
                                            <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ mọi nguồn (Offline + Online) bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>
                                                Tổng thực thu bán hàng: <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </div>
                                        <div className={styles.textTag}>
                                            {convertCurrency(totalPaidNoTax)}
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                        <div className={styles.textTag3}>
                                            <Tooltip className="show-tooltip" title='Tổng số đơn hàng các nguồn tư vấn, nếu đơn hàng upsale hai người tư vấn khác nhau thì đơn upsale cũng tính là một đơn mới bạn đầu tiên, đơn thứ hai được tính đơn mới cho người thứ hai. Chỉ được tính khi đơn hàng lần đâu tiên được thanh toán. Không tính đơn nạp tiền'> 
                                                Tổng số lượng hoá đơn:  <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </div>
                                        <div className={styles.textTag}> {totalOrderNew}</div>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                        <div className={styles.textTag3}>
                                            <Tooltip className="show-tooltip" title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn mọi nguồn tư vấn tại cơ sở chọn.'> 
                                                Doanh số thuần tư vấn <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </div>
                                        <div className={styles.textTag}>{convertCurrency(totalPrice)}</div>
                                    </div>  
                                </Tag>
                            </Col>

                            <Col xs={6} md={3} className="pay_type p-2">                   
                                <Tag color="green" className="w-100 p-2 h-100">
                                    <span className={styles.textTag2}>
                                    <Tooltip className="show-tooltip" title='Tổng số tiền thu được từ các hoạt động bán thẻ dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ qua các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy.'> Tiền đã thu nhóm dịch vụ: <i className="fas fa-info-circle"></i></Tooltip>
                                    </span>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <p className={styles.textTag4}>Triệt lông:</p> 
                                            <p className={styles.textTag4}>Da: </p> 
                                            <p className={styles.textTag4}>Chăm sóc Body:</p>
                                            <p className={styles.textTag4}>Mỹ phẩm:</p>
                                            <p className={styles.textTag4}>Đầu triệt:</p>
                                            <p className={styles.textTag4}>Gội đầu:</p>
                                        </div>
                                        <div className="ml-3">
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.triet?.paid ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.da?.paid ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.body?.paid ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.myPham?.paid ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.dauTriet?.paid ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.goi?.paid ?? 0)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={3} className="pay_type p-2">                   
                                <Tag color="green" className="w-100 p-2 h-100">
                                    <span className={styles.textTag2}>
                                    <Tooltip className="show-tooltip" title='Tiền đã thu trừ thuế'> Thực thu bán hàng nhóm dịch vụ: <i className="fas fa-info-circle"></i></Tooltip>
                                    </span>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <p className={styles.textTag4}>Triệt lông:</p> 
                                            <p className={styles.textTag4}>Da: </p> 
                                            <p className={styles.textTag4}>Chăm sóc Body:</p>
                                            <p className={styles.textTag4}>Mỹ phẩm:</p>
                                            <p className={styles.textTag4}>Đầu triệt:</p>
                                            <p className={styles.textTag4}>Gội đầu:</p>
                                        </div>
                                        <div className="ml-3">
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.triet?.paidNoTax ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.da?.paidNoTax ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.body?.paidNoTax ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.myPham?.paidNoTax ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.dauTriet?.paidNoTax ?? 0)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(dataByCategory?.goi?.paidNoTax ?? 0)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={3} className="pay_type p-2">                   
                                <Tag color="violet" className="w-100 p-2 h-100">
                                    <span className={styles.textTag2}>Tổng hoá đơn nhóm dịch vụ</span>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <p className={styles.textTag4}>Triệt lông:</p> 
                                            <p className={styles.textTag4}>Da: </p> 
                                            <p className={styles.textTag4}>Chăm sóc Body:</p>
                                            <p className={styles.textTag4}>Mỹ phẩm:</p>
                                            <p className={styles.textTag4}>Đầu triệt:</p>
                                            <p className={styles.textTag4}>Gội đầu:</p>
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag3}>{dataByCategory?.triet?.count ?? 0}</span>
                                            <span className={styles.textTag3}>{dataByCategory?.da?.count ?? 0}</span>
                                            <span className={styles.textTag3}>{dataByCategory?.body?.count ?? 0}</span>
                                            <span className={styles.textTag3}>{dataByCategory?.myPham?.count ?? 0}</span>
                                            <span className={styles.textTag3}>{dataByCategory?.dauTriet?.count ?? 0}</span>
                                            <span className={styles.textTag3}>{dataByCategory?.goi?.count ?? 0}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} md={5} className="hide-mobile">
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <Line {...config} />
                        </div>
                    </Col>
                    <Col xs={12} md={7}>
                        <div style={{ backgroundColor: "white" }} >
                            <div className="border-bottom mb-1 p-2">
                                <strong className="m-2">Bảng dữ liệu chi tiết</strong>
                            </div>
                            <div style={{ width: '100%' }} className="p-2">
                                <Table 
                                    columns={columns} 
                                    dataSource={rows}
                                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['5', '15', '30', '50', '100'] }}
                                    scroll={{ x: columns.length*200, y: 600 }}
                                    onChange={handleChange}
                                    bordered
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div >

    )
}
const configChart = (data, convertCurrency) => {  
    var config = {
        data: data,
        xField: "date",
        yField: "value",
        seriesField: "type",
        height: 520,
        xAxis: {
          title: {
            text: "Kinh Doanh",
            position: "end",
            offset: 0,
            spacing: 8,
            style: {
              fontSize: 13,
              fontWeight: 900,
              textAlign: "start"
            }
          },
          line: {
            style: {
              stroke: "black"
            }
          },
          tickLine: {
            style: {
              stroke: "black"
            }
          },
          label: {
            autoRotate: true,
            style: {
              fill: "black",
            //   fontSize: 10
            },
            formatter: (text) => {
              const oldLabel = text;
              const labelLength = oldLabel.replace(/[^x00-xff]/g, "xx").length;
              let newLabel = "";
              if (labelLength > 12) {
                let strLen = 0;
                let firstStr = "";
                let lastStr = "";
                for (let i = 0; i < labelLength; i++) {
                  if (oldLabel.charCodeAt(i) > 128) {
                    strLen += 2;
                  } else {
                    strLen++;
                  }
                  if (strLen <= 12) {
                    firstStr += oldLabel.charAt(i);
                  } else {
                    lastStr += oldLabel.charAt(i);
                  }
                }
                newLabel = `${firstStr}\n${lastStr}`;
              } else {
                newLabel = oldLabel;
              }
              return newLabel;
            }
          }
        },
        yAxis: {
          line: {
            style: {
              lineWidth: 2
            }
          },
          label: {
            style: {
              fill: "black"
            },
            offset: 15,
            formatter: (text) => _.round(_.divide(text, 1), 2).toLocaleString()
          }
        },
        color: ["#673ab7", "#2196f3", "#4caf50"],
        legend: {
          position: "right",
          marker: {
            symbol: "square"
          },
          itemName: {
            formatter: (text, item, index) => {
    
              return '';
            }
          }
        },
        point: [{
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#673ab7',
                lineWidth: 2,
            },
        }, {
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#2196f3',
                lineWidth: 2,
            },
        },
        {
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#4caf50',
                lineWidth: 2,
            },
        }],
        tooltip: {
            customContent: (count, data) => {
                let fileHtml = ''
                let title = ''
                for(let item of data) {
                    title = item.title
                    let name = item.name
                    let value = item.value
                    if (name != "Đơn hàng mới") {
                        value = convertCurrency(item.value)
                    }
                    fileHtml += '<li class="g2-tooltip-list-item">'
                    fileHtml += '<span class="g2-tooltip-marker" style="background: '+item.color+'; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px;">' + '</span>'
                    fileHtml += '<span class="g2-tooltip-name" style="color: '+item.color+';">'+item.name + '</span>'
                    fileHtml += '<span class="g2-tooltip-value" style="color: '+item.color+';">'+ value + '</span>'
                    fileHtml += '</li>'
                }
                return `<div class="g2-tooltip-title" style="margin-bottom: 12px; margin-top: 12px; padding-top: 12px; font-weight: bold; font-size: 15px"><p> ${title} </div>
                    <ul class="g2-tooltip-list" style="margin: 0px; list-style-type: none; padding: 12px !important; ">
                        ${fileHtml}
                        </br>
                    </ul>
                </div>`;
            }
        },
      };
    return config
}
export default ReportBusiness